import { ChangeEvent, useCallback, useRef, useState } from 'react'
import { HugeiconsIcon } from '@hugeicons/react'
import { PencilEdit01Icon } from '@hugeicons/core-solid-rounded'

import CropperDialog from '@/components/ui/CropperDialog'
import { Avatar } from './Avatar'
import useUploadAvatar from '../hooks/useUploadAvatar'
import { useCurrentUser } from '../hooks/useCurrentUser'

export function EditAvatarButton() {
  const inputRef = useRef<HTMLInputElement>(null)

  const { user } = useCurrentUser()
  const [upload] = useUploadAvatar()

  const [file, setFile] = useState<File | null>()

  const onChangeFile = useCallback(
    async function (event: ChangeEvent<HTMLInputElement>) {
      if (event.target.files && event.target.files.length > 0) {
        const file = event.target.files[0]

        setFile(file)
      }
    },
    [setFile]
  )

  const onDoneCropping = useCallback(
    (file: File) => {
      upload(file)

      setFile(null)
    },
    [setFile, upload]
  )

  const onCancelCropping = useCallback(() => {
    setFile(null)
  }, [setFile])

  return (
    <div className="flex flex-row">
      <button
        className="size-24 relative rounded-full"
        type="button"
        tabIndex={0}
        onClick={() => inputRef.current?.click()}
      >
        <HugeiconsIcon
          icon={PencilEdit01Icon}
          className="absolute right-0 top-0 rounded-full bg-black/80 text-white p-1"
        />
        <Avatar url={user.avatarUrl} />
        <input
          type="file"
          accept="image/*"
          className="invisible size-0"
          ref={inputRef}
          onChange={onChangeFile}
        />
      </button>
      <CropperDialog
        onDone={onDoneCropping}
        onCancel={onCancelCropping}
        file={file}
        allowPadding
        aspectRatio={1}
        shape="round"
      />
    </div>
  )
}
